<template>
  <div class="other-bg" :style="{ backgroundImage: 'url(' + BG + ')' }">
    <loading :active.sync="isLoading"></loading>
    <div class="container-cm">
      <div class="sidemap">
        <a href="#U" title="中央內容區塊" id="AU" accesskey="U" name="U">:::</a>
      <a href="/Sitemap" title="網站導覽">網站導覽</a>
      </div>
    </div>
    <div class="container-cm">
      <h1 class="logo">
        <a href="/" title="農科院農業課程報名及查詢系統:回首頁">
          <img src="../assets/images/LOGO.png" alt="農科院農業課程報名及查詢系統:回首頁" />
        </a>
      </h1>
      <main class="training-content">
        <h2 :class="!ms_ie?'training-h2':'training-h2-ie'">課程介紹</h2>
        <div class="table-line"></div>
        <div class="training-detail-container">
          <div class="training-detail-content">
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C">:::</a>
            <div class="list" v-if="trainingDetail.Id">
              <span class="title">課程代碼</span>
              <span class="content">{{trainingDetail.Number}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Title">
              <span class="title">課程名稱</span>
              <span class="content">{{trainingDetail.Title}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Prerequisite && trainingDetail.Prerequisite.length !== 0">
              <span class="title">先修課程</span>
              <span class="content" v-for="item in trainingDetail.Prerequisite" :key="item.Id">{{item.Title}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Organizer">
              <span class="title">承辦單位</span>
              <span class="content">{{trainingDetail.Organizer}}</span>
            </div>
            <div class="list" v-if="trainingDetail.OrganizedBy">
              <span class="title">承辦人</span>
              <span class="content">{{trainingDetail.OrganizedBy}}</span>
            </div>
            <div class="list" v-if="trainingDetail.ContactPhone">
              <span class="title">連絡電話</span>
              <span class="content">{{trainingDetail.ContactPhone}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Content">
              <span class="title">課程說明</span>
              <span class="content" style="white-space: pre-line;">{{trainingDetail.Content}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Fee > 0">
              <span class="title">課程費用</span>
              <span class="content">{{trainingDetail.Fee}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Echelon">
              <span class="title">梯次</span>
              <span class="content">{{trainingDetail.Echelon}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Hours">
              <span class="title">認列時數</span>
              <span class="content">{{trainingDetail.Hours}}</span>
            </div>
            <div class="list" v-if="trainingDetail.ParticipantStartOn">
              <span class="title">報名日期</span>
              <span class="content">{{ trainingDetail.ParticipantStartOn | moment('YYYY.MM.DD')}} ~ {{ trainingDetail.ParticipantEndOn | moment('YYYY.MM.DD')}}</span>
            </div>
            <div class="list" v-if="trainingDetail.StartOn">
              <span class="title">課程日期</span>
              <span class="content">{{ trainingDetail.StartOn | moment('YYYY.MM.DD HH:mm')}}~{{ trainingDetail.EndOn | moment('YYYY.MM.DD HH:mm')}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Quota">
              <span class="title">招收名額</span>
              <span class="content">{{trainingDetail.Quota}}</span>
            </div>
            <div class="list" v-if="trainingDetail.LimitDescription">
              <span class="title">招收限制</span>
              <span class="content" style="white-space: pre-line;">{{trainingDetail.LimitDescription}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Note">
              <span class="title">注意事項</span>
              <span class="content" style="white-space: pre-line;">{{trainingDetail.Note}}</span>
            </div>
            <div class="list" v-if="trainingDetail.Location">
              <span class="title">地點</span>
              <span class="content">{{trainingDetail.Location}}</span>
            </div>
            <div class="list" v-if="trainingDetail.DocumentFile">
              <span class="title">附件</span>
              <span class="content">
                <div v-for="(item,index) in DocumentFile" :key="index"><a :href="item" :title="`下載${item.split('/')[4]}`" :download="item.split('/')[4].split('.')[0]">{{item.split('/')[4]}}</a><br></div>
              </span>
            </div>
            <div class="btn-box">
              <a v-if="!isOver" class="btn light-green" :href="`/Course/Participant/${trainingDetail.Id}`" title="前往報名">報名</a>
              <a v-else class="btn light-green over" href="#" title="已結束報名">已結束</a>
              <a class="btn dark-green" href="/Course/Index" title="回列表頁">回列表</a>
            </div>
          </div>
        </div>
      </main>
    <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Api from '@/assets/api/course';
import Footer from '@/components/Footer.vue';
import BG from '../assets/images/content_BG01.jpg';

export default {
  name: 'trainingdetail',
  props: {
    course: {
      type: Object,
    },
  },
  components: {
    Footer,
  },
  data() {
    return {
      BG,
      trainingDetail: {},
      isChecked: false,
      // eslint-disable-next-line global-require
      scarecrowImg: require('../assets/images/scarecrow.png'),
      alertSet: {
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: '確定',
        confirmButtonAriaLabel: '確定',
        cancelButtonText: '取消',
        cancelButtonAriaLabel: '取消',
        closeButtonAriaLabel: '關閉視窗',
        reverseButtons: true,
        confirmButtonColor: '#4dba95',
        cancelButtonColor: '#bfbfbf',
        width: '1200px',
        html: '',
        focusConfirm: false,
      },
      choosedTraining: '',
      isLoading: false,
      isEmpty: true,
      DocumentFile: [],
      ms_ie: false,
      isOver: false,
    };
  },
  methods: {
    getDetail(id) {
      const vm = this;
      vm.isLoading = true;
      Api.getCourseDetail(id).then((res) => {
        vm.isLoading = false;
        if (res.status === 200) {
          vm.trainingDetail = res.data.Data;
          if (vm.trainingDetail.DocumentFile) {
            vm.DocumentFile = vm.trainingDetail.DocumentFile.split(',');
          }
          vm.overCheck();
        }
      });
    },
    overCheck() {
      const vm = this;
      const now = new Date();
      const start = new Date(vm.trainingDetail.ParticipantStartOn);
      const end = new Date(vm.trainingDetail.ParticipantEndOn);
      if (start > now) {
        vm.isOver = true;
      } else if (now > start && now < end) {
        vm.isOver = false;
      } else if (now > end) {
        vm.isOver = true;
      } else if (vm.trainingDetail.ParticipantCount >= vm.trainingDetail.Limit) {
        vm.isOver = true;
      }
    },
  },
  created() {
    const vm = this;
    if (vm.course) {
      vm.trainingDetail = JSON.parse(vm.course);
      if (vm.trainingDetail.DocumentFile) {
        vm.DocumentFile = vm.trainingDetail.DocumentFile.split(',');
      }
      vm.overCheck();
    } else {
      vm.getDetail(vm.$route.params.trainingId);
    }
    const ua = window.navigator.userAgent;
    const oldIe = ua.indexOf('MSIE ');
    const newIe = ua.indexOf('Trident/');
    if ((oldIe > -1) || (newIe > -1)) {
      vm.ms_ie = true;
    }
  },
  filters: {
    dayFormat(data) {
      return data.split('.')[2].split(' ')[0];
    },
    monthFormat(data) {
      let tmpMonth = data.split('.');
      switch (tmpMonth[1]) {
        case '01':
          tmpMonth = 'JAN';
          break;
        case '02':
          tmpMonth = 'FEB';
          break;
        case '03':
          tmpMonth = 'MAR';
          break;
        case '04':
          tmpMonth = 'APR';
          break;
        case '05':
          tmpMonth = 'MAY';
          break;
        case '06':
          tmpMonth = 'JUN';
          break;
        case '07':
          tmpMonth = 'JUL';
          break;
        case '08':
          tmpMonth = 'AUG';
          break;
        case '09':
          tmpMonth = 'SEP';
          break;
        case '10':
          tmpMonth = 'OCT';
          break;
        case '11':
          tmpMonth = 'NOV';
          break;
        case '12':
          tmpMonth = 'DEC';
          break;

        default:
          break;
      }
      return tmpMonth;
    },
  },
};
</script>

<style lang="scss" scoped>

.other-bg {
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}

.training-content {
  padding: 0 4rem 300px 4rem;
  @media (max-width: 1024px) {
    padding: 0 0 300px 0;
  }
}

.training-h2 {
  background: linear-gradient(to bottom, #a0c8c0 0, #5aa3a8 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h2-ie {
  color: #5aa3a8;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h3 {
  font-size: 1.5rem;
  text-align-last: left;
}

.table-line {
  height: 1px;
  background-color: #edf1f1;
  width: 100%;
}

#AC,#AU {
  color: transparent;
}

.training-detail-container {
  padding: 0.6rem 5rem;
  @media (max-width: 1024px) {
    padding: 0.6rem 0;
  }
}

.training-detail-content {
  background-color: #fff;
  border-radius: 1rem;
  padding: 4.5rem 5rem 4.5rem 9rem;
  box-shadow: 0 0 3px 3px rgba(227, 232, 232, 0.5);
  @media (max-width: 1024px) {
    padding: 1.5rem;
  }
  .list {
    display: flex;
    font-size: 1.1rem;
    color: #3e3e3f;
    letter-spacing: 1.5px;
    line-height: 2;
    @media (max-width: 420px) {
    flex-direction: column;
    margin-bottom: 2rem;
  }
    .title {
      min-width: 100px;
      display: inline-block;
      text-align: right;
      margin-right: 30px;
      @media (max-width: 420px) {
    text-align: left;
  }
    }
    .content {
      width: 100%;
      display: inline-block;
    }
  }
  .btn-box {
    display: flex;
    justify-content: flex-end;
    padding-top: 5.5rem;
    @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }

  a:first-child {
    margin-right: 1.5rem;

    @media (max-width: 767px) {
      margin-right: 0;
      margin-bottom: 1.5rem;
    }
  }
  }
  .btn {
  display: block;
  color: #fff;
  border-radius: 5rem;
  padding: 0.5rem 0;
  width: 120px;
  font-size: 1.5rem;
  letter-spacing: 5px;
  text-decoration: none;
  text-align: center;

  &.light-green {
    background-color: #4dba95;

    &.over {
      background-color: #b6b6b6;
      pointer-events: none;
      cursor: default;
    }
  }

  &.dark-green {
    background-color: #8bb75f;
  }
}
}

</style>

<style lang="scss">
.pop-check {
  text-align: center;
  font-size: 1.5rem;
  color: #f98d28;
  padding: 10px 0;
  input[type="checkbox"] {
    border: 2px solid #f98d28;
    width: 16px;
    height: 16px;
  }
}

// sweetalert 客製
.swal2-content {
  padding: 0 1rem;

  p {
    text-align-last: left;
    font-size: 1.1rem;
  }
}

.swal2-styled.swal2-confirm,
.swal2-styled.swal2-cancel {
  font-size: 1.5rem;
  border-radius: 5rem;
  font-weight: bold;
  padding: 10px 55px;
}

.swal2-styled:focus {
  outline: 3px dashed #5da3ab;
}

</style>
